/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'resource/credit': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm6.707 10.707L14.414 13l1.543 1.543a.999.999 0 11-1.414 1.414L13 14.414l-2.293 2.293a.997.997 0 01-1.414 0L7 14.414l-1.543 1.543a.997.997 0 01-1.414 0 .999.999 0 010-1.414L5.586 13l-2.293-2.293a.999.999 0 010-1.414L5.586 7 4.043 5.457a.999.999 0 111.414-1.414L7 5.586l2.293-2.293a.999.999 0 011.414 0L13 5.586l1.544-1.543a.999.999 0 111.414 1.414L14.414 7l2.293 2.293a.999.999 0 010 1.414z"/><path pid="1" d="M10 14.586l-4.586-4.585L10 5.415l4.586 4.586z"/>'
  }
})
